import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {
  TrackingEventPayload
} from '../../entities/tracking/tracking-event.entity';

export interface TrackEventResponse {
  status: 'ok';
}

@Injectable({
  providedIn: 'root'
})
export class TrackingApiService {
  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  public trackEvent(
    event: TrackingEventPayload,
  ): Observable<TrackEventResponse> {
    return this.http.post<TrackEventResponse>(`${environment.apiUrl}/api/v1/tracking/events`, {
      name: event.name,
      flow: event.flow ?? null,
      trackingId: event.trackingId ?? null,
      occurredAt: event.occurredAt ?? null,
      idempotencyKey: event.idempotencyKey ?? null,
      payload: event.payload ?? null,
    });
  }
}
